export default class VideoWidthImage {
    constructor($el) {
        this.$el = $el;
        this.$iframe = this.$el.querySelector('[data-iframe]');
        this.$image = this.$el.querySelector('[data-image]');

        this.showIframe = this.showIframe.bind(this);

        this.$el.addEventListener('click', this.showIframe);
    }

    showIframe () {
        this.$image.classList.add('d-none');
    }
}